module.exports = __webpack_public_path__ + "img/guarani.ea17e71d.svg";